import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { extractComponents } from '~/utils/contentful';
import validateImageObject from '~/helpers/validateImageObject';
import BlockImagesText from '~/components/cms/custom/BlockImagesText/BlockImagesText.vue';
import BlockBlockList from '~/components/cms/custom/BlockBlockList/BlockBlockList.vue';
export default defineComponent({
  name: 'RenderContent',
  components: {
    BlockBlockList: BlockBlockList,
    BlockImagesText: BlockImagesText,
    LabeledLink: function LabeledLink() {
      return import('~/components/cms/custom/LabeledLink/LabeledLink.vue');
    },
    BlockCardList: function BlockCardList() {
      return import('~/components/cms/custom/BlockCardList.vue');
    },
    BlockTabsWithBanner: function BlockTabsWithBanner() {
      return import('~/components/cms/custom/BlockTabsWithBanner/BlockTabsWithBanner.vue');
    },
    BlockRecipeCategories: function BlockRecipeCategories() {
      return import('~/components/cms/custom/BlockRecipeCategories.vue');
    },
    BlockAdviceTabsWithBanner: function BlockAdviceTabsWithBanner() {
      return import('~/components/cms/custom/BlockAdviceTabsWithBanner/BlockAdviceTabsWithBanner.vue');
    },
    BlockOurEngagements: function BlockOurEngagements() {
      return import('~/components/cms/custom/BlockOurEngagements.vue');
    },
    BlockSeoMainTitle: function BlockSeoMainTitle() {
      return import('~/components/cms/custom/BlockSeoMainTitle.vue');
    },
    BlockRatingsAndReviews: function BlockRatingsAndReviews() {
      return import('~/components/cms/custom/BlockRatingsAndReviews.vue');
    },
    AdvancedTabsItem: function AdvancedTabsItem() {
      return import('~/components/cms/custom/AdvancedTabsItem.vue');
    },
    BlockTitle: function BlockTitle() {
      return import('~/components/cms/custom/BlockTitle/BlockTitle.vue');
    },
    BlockTabsContainer: function BlockTabsContainer() {
      return import('~/components/cms/custom/BlockTabsContainer/BlockTabsContainer.vue');
    },
    BlockTeaserText: function BlockTeaserText() {
      return import('~/components/cms/custom/BlockTeaserText.vue');
    },
    BlockExpandableTab: function BlockExpandableTab() {
      return import('~/components/cms/custom/BlockExpandableTab/BlockExpandableTab.vue');
    },
    BlockDosage: function BlockDosage() {
      return import('~/components/cms/custom/BlockDosage.vue');
    },
    ItemTabDosage: function ItemTabDosage() {
      return import('~/components/cms/custom/ItemTabDosage.vue');
    },
    BlockImageTextList: function BlockImageTextList() {
      return import('~/components/cms/custom/BlockImageTextList/BlockImageTextList.vue');
    },
    BlockTextList: function BlockTextList() {
      return import('~/components/cms/custom/BlockTextList/BlockTextList.vue');
    },
    BlockImage: function BlockImage() {
      return import('~/components/cms/custom/BlockImage.vue');
    },
    BlockEnumeration: function BlockEnumeration() {
      return import('~/components/cms/custom/BlockEnumeration/BlockEnumeration.vue');
    },
    BlockRecipePreparationSteps: function BlockRecipePreparationSteps() {
      return import('~/components/cms/custom/BlockRecipePreparationSteps.vue');
    },
    ItemRecipePreparationStep: function ItemRecipePreparationStep() {
      return import('~/components/cms/custom/ItemRecipePreparationStep.vue');
    },
    BlockDownloadableFiles: function BlockDownloadableFiles() {
      return import('~/components/cms/custom/BlockDownloadableFiles.vue');
    },
    ContentRecipeIngredient: function ContentRecipeIngredient() {
      return import('~/components/cms/custom/ContentRecipeIngredient.vue');
    },
    BlockIngredients: function BlockIngredients() {
      return import('~/components/cms/custom/BlockIngredients/BlockIngredients.vue');
    },
    ContentRecipeEquipment: function ContentRecipeEquipment() {
      return import('~/components/cms/custom/ContentRecipeEquipment.vue');
    },
    BlockExpandableLink: function BlockExpandableLink() {
      return import('~/components/cms/custom/BlockExpandableLink/BlockExpandableLink.vue');
    },
    BlockRichTextList: function BlockRichTextList() {
      return import('~/components/cms/custom/BlockRichTextList.vue');
    },
    ContentSimpleTab: function ContentSimpleTab() {
      return import('~/components/cms/custom/ContentSimpleTab.vue');
    },
    BlockIconLabeledLinks: function BlockIconLabeledLinks() {
      return import('~/components/cms/custom/BlockIconLabeledLinks.vue');
    },
    BlockImageList: function BlockImageList() {
      return import('~/components/cms/custom/BlockImageList.vue');
    },
    BlockTwoColumnsTextList: function BlockTwoColumnsTextList() {
      return import('~/components/cms/custom/BlockTwoColumnsTextList.vue');
    },
    BlockCategorizedTabContainer: function BlockCategorizedTabContainer() {
      return import('~/components/cms/custom/BlockCategorizedTabContainer.vue');
    },
    ItemCategorizedTab: function ItemCategorizedTab() {
      return import('~/components/cms/custom/ItemCategorizedTab.vue');
    },
    BlockTwoColumnsImageText: function BlockTwoColumnsImageText() {
      return import('~/components/cms/custom/BlockTwoColumnsImageText.vue');
    },
    BlockFullText: function BlockFullText() {
      return import('~/components/cms/custom/BlockFullText.vue');
    },
    BlockTwoSidedCardList: function BlockTwoSidedCardList() {
      return import('~/components/cms/custom/BlockTwoSidedCardList.vue');
    },
    ItemTwoSidedCard: function ItemTwoSidedCard() {
      return import('~/components/cms/custom/ItemTwoSidedCard.vue');
    },
    BlockDoubleTextList: function BlockDoubleTextList() {
      return import('~/components/cms/custom/BlockDoubleTextList/BlockDoubleTextList.vue');
    },
    BlockPercentageList: function BlockPercentageList() {
      return import('~/components/cms/custom/BlockPercentageList.vue');
    },
    BlockStackableTabs: function BlockStackableTabs() {
      return import('~/components/cms/custom/BlockStackableTabs.vue');
    },
    BlockRankList3Levels: function BlockRankList3Levels() {
      return import('~/components/cms/custom/BlockRankList3Levels/BlockRankList3Levels.vue');
    },
    BlockEquivalence: function BlockEquivalence() {
      return import('~/components/cms/custom/BlockEquivalence.vue');
    },
    ItemRank5Levels: function ItemRank5Levels() {
      return import('~/components/cms/custom/ItemRank5Levels.vue');
    },
    ItemStackableTabs: function ItemStackableTabs() {
      return import('~/components/cms/custom/ItemStackableTabs.vue');
    },
    BlockContactForm: function BlockContactForm() {
      return import('~/components/cms/custom/BlockContactForm.vue');
    },
    ItemLinkAxeptioModal: function ItemLinkAxeptioModal() {
      return import('~/components/cms/custom/ItemLinkAxeptioModal.vue');
    },
    ItemTwoTextImageList: function ItemTwoTextImageList() {
      return import('~/components/cms/custom/ItemImageText/ItemImageTextTwo.vue');
    }
  },
  props: {
    content: {
      type: [Array, Object]
    }
  },
  computed: {
    components: function components() {
      // OOTB getImageObject function fix
      validateImageObject(this.content);
      return extractComponents(this.content);
    }
  }
});